import * as React from 'react'
import styled from 'styled-components'
import { SAFE_AREA_INSET_TOP } from 'utils/style'

const Component = ({ children, ...props }) => {
  return <Frame {...props}>{children}</Frame>
}

const Frame = styled.main`
  margin: 0 auto;
  background-color: white;
  max-width: 600px;
  min-height: 100vh;
  height: 1px;
  padding-top: ${SAFE_AREA_INSET_TOP};
`

export default Component
